// src/main.ts — Entry point for tagdiv_theme bundle
//
// This file imports all modules (triggering their side effects in dependency
// order), assigns public APIs to window for PHP template inline scripts,
// and runs the tdMenu init that was a standalone jQuery.ready() in the
// original monolith.

import jQuery from 'jquery';

// ── Vendor (side-effect only — register jQuery plugins / polyfills) ──────────
import './vendor/raf-polyfill';
import './vendor/placeholder-polyfill';
import 'jquery.easing';
import './vendor/supersubs';
import './vendor/ios-slider';
import 'magnific-popup';

// ── Analytics ────────────────────────────────────────────────────────────────
import { tdAnalytics } from './analytics/analytics';

// ── Core (dependency order matters) ──────────────────────────────────────────
import { tdDetect }       from './core/detect';
import { tdUtil }         from './core/util';
import { tdViewport }     from './core/viewport';
import { tdCustomEvents } from './core/custom-events';
import { tdEvents }       from './core/events';

// ── Layout ────────────────────────────────────────────────────────────────────
import { tdAffix }        from './layout/affix';
import { tdMenu }         from './layout/menu';
import { tdSmartSidebar } from './layout/smart-sidebar';
import { tdPullDown }     from './layout/pull-down';
import { td_mobile_menu, td_mobile_menu_toogle } from './layout/mobile-menu';

// ── Blocks ────────────────────────────────────────────────────────────────────
import { tdBlocks }          from './blocks/blocks';
import { tdAjaxLoop }        from './blocks/ajax-loop';
import { tdInfiniteLoader }  from './blocks/infinite-loader';
import { tdTrendingNow }     from './blocks/trending-now';

// ── Search ────────────────────────────────────────────────────────────────────
import { tdAjaxSearch }  from './search/ajax-search';

// ── Animation ────────────────────────────────────────────────────────────────
import { tdAnimationStack }  from './animation/animation-stack';
import { tdAnimationScroll, tdHomepageFull, tdBackstr } from './animation/animation-scroll';
import { tdAnimationSprite } from './animation/animation-sprite';

// ── Media ─────────────────────────────────────────────────────────────────────
import { tdYoutubePlayers } from './media/youtube-player';
import { tdVimeoPlayers }   from './media/vimeo-player';
import { td_resize_videos } from './media/resize-videos';
import { tdModalImage }     from './media/modal-image';
import './media/smartlist-slider';  // side-effect only (jQuery ready/load handlers)

// ── Auth ──────────────────────────────────────────────────────────────────────
import { tdLogin }    from './auth/login';
import { tdLoginMob } from './auth/login-mobile';

// ── Misc ──────────────────────────────────────────────────────────────────────
import { tdLoadingBox }         from './misc/loading-box';
import { tdAjaxCount }          from './misc/ajax-count';
import { td_retina }            from './misc/retina';
import { td_history }           from './misc/history';
import { td_more_articles_box } from './misc/more-articles';
import { tdSocialSharing }      from './misc/social-sharing';
import { tdWeather }            from './misc/weather';
import { td_date_i18n }         from './misc/date-i18n';
import { td_fps, setMenuMinHeight, td_smart_lists_magnific_popup, td_smart_list_dropdown, td_comments_form_validation, td_scroll_to_class } from './misc/scroll-helpers';
import './misc/demo-menu';      // side-effect: gated by __DEMO_MODE__

// ── Expose public APIs on window for PHP template inline scripts ─────────────
// These assignments MUST remain — PHP templates call these by global name.
(window as any).tdAnalytics      = tdAnalytics;
(window as any).tdDetect         = tdDetect;
(window as any).tdUtil           = tdUtil;
(window as any).tdViewport       = tdViewport;
(window as any).tdCustomEvents   = tdCustomEvents;
(window as any).tdEvents         = tdEvents;
(window as any).tdAffix          = tdAffix;
(window as any).tdMenu           = tdMenu;
(window as any).tdSmartSidebar   = tdSmartSidebar;
(window as any).tdPullDown       = tdPullDown;
(window as any).tdBlocks         = tdBlocks;
(window as any).tdAjaxLoop       = tdAjaxLoop;
(window as any).tdInfiniteLoader = tdInfiniteLoader;
(window as any).tdTrendingNow    = tdTrendingNow;
(window as any).tdAjaxSearch     = tdAjaxSearch;
(window as any).tdAnimationStack  = tdAnimationStack;
(window as any).tdAnimationScroll = tdAnimationScroll;
(window as any).tdAnimationSprite = tdAnimationSprite;
(window as any).tdHomepageFull   = tdHomepageFull;
(window as any).tdBackstr        = tdBackstr;
(window as any).tdYoutubePlayers = tdYoutubePlayers;
(window as any).tdVimeoPlayers   = tdVimeoPlayers;
(window as any).tdLogin          = tdLogin;
(window as any).tdLoginMob       = tdLoginMob;
(window as any).tdLoadingBox     = tdLoadingBox;
(window as any).tdAjaxCount      = tdAjaxCount;
(window as any).tdSocialSharing  = tdSocialSharing;
(window as any).tdWeather        = tdWeather;
(window as any).td_history       = td_history;
(window as any).td_more_articles_box = td_more_articles_box;
(window as any).td_resize_videos = td_resize_videos;
(window as any).td_retina        = td_retina;
(window as any).td_date_i18n     = td_date_i18n;
(window as any).td_fps           = td_fps;
(window as any).tdModalImage     = tdModalImage;
(window as any).td_mobile_menu   = td_mobile_menu;
(window as any).td_mobile_menu_toogle = td_mobile_menu_toogle;

// ── DOM-ready init (mirrors the original tagdiv_theme monolith's jQuery.ready block) ─
jQuery().ready(function() {
    'use strict';
    td_retina();
    td_mobile_menu_toogle();
    td_resize_videos();
    jQuery( 'input, textarea' ).placeholder();
    td_more_articles_box.init();
    td_smart_lists_magnific_popup();
    td_smart_list_dropdown();

    if ( typeof (window as any).tdsDateFormat !== 'undefined' ) {
        const now = Math.floor( new Date().getTime() / 1000 );
        jQuery( '.td_data_time' ).text( td_date_i18n( (window as any).tdsDateFormat, now ) );
    }

    setMenuMinHeight();
    td_comments_form_validation();
    td_scroll_to_class();
    tdMenu.init();
});
